import esContent from './domains.es';

export default {
  ...esContent,
};
